app.directive('domainsBreadcrumb', [
    '$rootScope',
    function ($rootScope) {
        var DEFAULT_BREADCRUMB = {
            parent_id: null,
            id: null,
            name: 'Tous les domaines'
        };
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                initialDivider: '=',
                entries: '='
            },
            template: '<span><span ng-if="breadcrumb.length && initialDivider" class="divider"> / </span><span ng-repeat="item in breadcrumb track by $index"><a class="section" ng-if="!$last" ng-bind="item.name" ng-click="goToDomain(item)"></a><div class="section active" ng-if="$last" ng-bind="item.name"></div><div ng-if="!$last" class="divider"> / </div></span></span>',
            link: function (scope) {
                scope.breadcrumb = [DEFAULT_BREADCRUMB];

                if (scope.entries && angular.isArray(scope.entries)) {
                    scope.breadcrumb = scope.entries;
                }

                scope.goToDomain = function (domain) {
                    $rootScope.$broadcast('regulation.domains.goTo', {domain: domain});
                };

                /**
                 * @param domain
                 * @returns {boolean}
                 */
                scope.HasEntry = function (domain) {
                    var filtered = scope.breadcrumb.filter(function (item) {
                        return item.name === domain.name;
                    });
                    return filtered !== undefined && filtered.length > 0;
                };

                $rootScope.$on('regulation.domains.breadcrumb.add', function (e, data) {
                    if (data.domain === undefined) {
                        return;
                    }
                    if (!scope.HasEntry(data.domain)) {
                        scope.breadcrumb.push(data.domain);
                    }
                });

                $rootScope.$on('regulation.domains.breadcrumb.remove', function (e, data) {
                    if (data.domain === undefined || !data.domain.id) {
                        scope.breadcrumb = [DEFAULT_BREADCRUMB];
                        return;
                    }
                    scope.breadcrumb = scope.breadcrumb.filter(function (item) {
                        return item.name !== data.domain.name;
                    });
                });

                $rootScope.$on('regulation.domains.breadcrumb.set', function (e, data) {
                    if (!data || !data.breadcrumb) {
                        return;
                    }

                    scope.breadcrumb = angular.isArray(data.breadcrumb)
                        ? (scope.entries && angular.isArray(scope.entries) ? scope.entries : [DEFAULT_BREADCRUMB]).concat(data.breadcrumb)
                        : scope.breadcrumb.push(data.breadcrumb);
                });
            }
        }
    }]);